import image from './image.jpg';

export default {
  name: 'Em branco',
  image,
  body: {
    instanceList: [],
    instances: {},
  },
};
